import React, { useEffect, useState } from 'react'
import "./style.css"
import ExcelJS from 'exceljs';
import { useAuth } from 'oidc-react';

const IndexNew = () => {

    const [responseData, setResponseData] = useState(null);
    const [finalData, setFinalData] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [serverData, setServerData] = useState([]);
    const department = 'someDepartment';
    const division = 'someDivision';
    console.log(selectedDepartment.length, 'selectedDepartment')
    const [totals, setTotals] = useState({});
    console.log("totals", totals);
    const { userData } = useAuth();
    console.log("finalData", userData)
    const handlePrint = () => {
        window.print();
    };
    //  useEffect(() => {
    //       fetch("https://ehrp-hr-webapi.azurewebsites.net/api/StaffingPattern/getEmployees").then(d => {
    //           d.json().then(response => {
    //               setResponseData(response);
    //           })
    //       });
    //   }, [])

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_DOTNET_URL}/StaffingPattern/getEmployees`).then(d => {
            d.json().then(response => {
                setResponseData(response);
            })
        });
    }, [])

    const sanitizeSheetName = (name) => {
        // Replace invalid characters with an underscore (_)
        return name.replace(/[\\\/\*\?\:\[\]=`'_<>|]/g, '_');
    };

    const downloadExcelByDivision = (finalData, department) => {

        // Create a new workbook
        const wb = new ExcelJS.Workbook();

        // Add a sheet for each division in the selected department
        Object.keys(finalData[department]).forEach((division, index) => {
            const divisionData = finalData[department][division];

            // Create a new sheet for the current division
            const sanitizedDivisionName = sanitizeSheetName(division);

            // Create a new sheet for the current division
            const ws = wb.addWorksheet(`Division ${index + 1} ${sanitizedDivisionName}`);

            const headers = [
                '', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', '', 'L (H+I+J+K)', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', '(M thru S)', '(L+T)'
            ];
            const headerRow = ws.addRow(headers);

            // Merge cells for "Increment Date" and "Increment Amt"
            ws.mergeCells('L1:M1'); // Adjust column letters to match the correct positions
            ws.getCell('L1').value = 'K Increment';
            ws.getCell('L1').alignment = { horizontal: 'center', vertical: 'middle' };

            // Style the first header row
            headerRow.eachCell((cell, colNumber) => {
                cell.style.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF1F77B4' } // Blue background
                };
                cell.style.font = {
                    bold: true,
                    color: { argb: 'FFFFFF' } // White text
                };
            });

            // Adding the second header row
            const additionalHeaders = [
                'Sr.No', 'Account Name', 'Funding Source', 'Pos No.', 'Position Title', 'Name Of Incumbent', 'Recent Hire Date', 'Grade / Step',
                'Annual Salary', 'O/T', 'Special', 'Date', 'Amt', 'Subtotal',
                'Retire', 'Retire(DDI)', 'Soc.Sec', 'Medicare', 'Life', 'Medical', 'Dental',
                'Total Benefits', 'Total'
            ];
            const additionalHeaderRow = ws.addRow(additionalHeaders);

            additionalHeaderRow.eachCell((cell, colNumber) => {
                if (cell.value) {
                    cell.style.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFFC000' } // Yellow background
                    };
                    cell.style.font = {
                        bold: true,
                        color: { argb: '000000' } // Black text
                    };
                }
            });


            // Add data rows
            divisionData.forEach((item, rowIndex) => {
                const row = [
                    rowIndex + 1,  // Sr. No.
                    item["AccountName"],
                    item["FundingSource"],
                    item["Pos No."],
                    item["Position Title"],
                    item["Name Of Incumbent"],
                    item["Recent Hire Date"] ? new Date(item["Recent Hire Date"]).toLocaleDateString('en-US') : '',
                    item["Grade /Step"],
                    item["Salary"] !== null ? item["Salary"].toLocaleString('en-US') : '',
                    item["O/T"] !== null ? item["O/T"].toLocaleString('en-US') : '',
                    item["Special"] !== null ? item["Special"].toLocaleString('en-US') : '',
                    item["Increment Date"] ? new Date(item["Increment Date"]).toLocaleDateString('en-US') : '',
                    item["Increment Amt"] !== null ? item["Increment Amt"].toLocaleString('en-US') : '',
                    item["Subtotal"] !== null ? item["Subtotal"].toLocaleString('en-US') : '',
                    item["Retire"] !== null ? item["Retire"].toLocaleString('en-US') : '',
                    item["Retire(DDI)"] !== null ? item["Retire(DDI)"].toLocaleString('en-US') : '',
                    item["Soc.Sec"] !== null ? item["Soc.Sec"].toLocaleString('en-US') : '',
                    item["Medicare"] !== null ? item["Medicare"].toLocaleString('en-US') : '',
                    item["Life"] !== null ? item["Life"].toLocaleString('en-US') : '',
                    item["Medical"] !== null ? item["Medical"].toLocaleString('en-US') : '',
                    item["Dental"] !== null ? item["Dental"].toLocaleString('en-US') : '',
                    item["Total Benefits"] !== null ? item["Total Benefits"].toLocaleString('en-US') : '',
                    item["Total"] !== null ? item["Total"].toLocaleString('en-US') : '',
                ];

                // Add the row to the worksheet
                ws.addRow(row);
            });
        });

        // Write the Excel file and trigger the download
        wb.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${department}_data_by_division.xlsx`;
            link.click();
        });
    };


    const downloadExcel = (finalData, department, division) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet 1');

        // Adding the first header row
        const headers = [
            '', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', '', 'L (H+I+J+K)', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', '(M thru S)', '(L+T)'
        ];
        const headerRow = worksheet.addRow(headers);

        // Merge cells for "Increment Date" and "Increment Amt"
        worksheet.mergeCells('L1:M1'); // Adjust column letters to match the correct positions
        worksheet.getCell('L1').value = 'K Increment';
        worksheet.getCell('L1').alignment = { horizontal: 'center', vertical: 'middle' };

        // Style the first header row
        headerRow.eachCell((cell, colNumber) => {
            cell.style.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1F77B4' } // Blue background
            };
            cell.style.font = {
                bold: true,
                color: { argb: 'FFFFFF' } // White text
            };
        });

        // Adding the second header row
        const additionalHeaders = [
            'Sr.No', 'Account Name', 'Funding Source', 'Pos No.', 'Position Title', 'Name Of Incumbent', 'Recent Hire Date', 'Grade / Step',
            'Annual Salary', 'O/T', 'Special', 'Date', 'Amt', 'Subtotal',
            'Retire', 'Retire(DDI)', 'Soc.Sec', 'Medicare', 'Life', 'Medical', 'Dental',
            'Total Benefits', 'Total'
        ];
        const additionalHeaderRow = worksheet.addRow(additionalHeaders);

        // Style the second header row
        additionalHeaderRow.eachCell((cell, colNumber) => {
            if (cell.value) {
                cell.style.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFC000' } // Yellow background
                };
                cell.style.font = {
                    bold: true,
                    color: { argb: '000000' } // Black text
                };
            }
        });

        // Adding the data rows for the Excel table
        finalData[department][division].map((item, index) => {
            const row = [
                index + 1,  // Sr. No.
                item["AccountName"],
                item["FundingSource"],
                item["Pos No."],
                item["Position Title"],
                item["Name Of Incumbent"],
                item["Recent Hire Date"] ? new Date(item["Recent Hire Date"]).toLocaleDateString('en-US') : '',
                item["Grade /Step"],
                item["Salary"] !== null ? item["Salary"].toLocaleString('en-US') : '',
                item["O/T"] !== null ? item["O/T"].toLocaleString('en-US') : '',
                item["Special"] !== null ? item["Special"].toLocaleString('en-US') : '',
                item["Increment Date"] ? new Date(item["Increment Date"]).toLocaleDateString('en-US') : '',
                item["Increment Amt"] !== null ? item["Increment Amt"].toLocaleString('en-US') : '',
                item["Subtotal"] !== null ? item["Subtotal"].toLocaleString('en-US') : '',
                item["Retire"] !== null ? item["Retire"].toLocaleString('en-US') : '',
                item["Retire(DDI)"] !== null ? item["Retire(DDI)"].toLocaleString('en-US') : '',
                item["Soc.Sec"] !== null ? item["Soc.Sec"].toLocaleString('en-US') : '',
                item["Medicare"] !== null ? item["Medicare"].toLocaleString('en-US') : '',
                item["Life"] !== null ? item["Life"].toLocaleString('en-US') : '',
                item["Medical"] !== null ? item["Medical"].toLocaleString('en-US') : '',
                item["Dental"] !== null ? item["Dental"].toLocaleString('en-US') : '',
                item["Total Benefits"] !== null ? item["Total Benefits"].toLocaleString('en-US') : '',
                item["Total"] !== null ? item["Total"].toLocaleString('en-US') : ''
            ];
            worksheet.addRow(row);
        });

        // Saving the file
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'final_data.xlsx'; // Name of the file to be downloaded
            link.click(); // Trigger the download
        });
    };

    const downloadAllExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('All Staffing Patterns');

        // First header row
        const headers = [
            '', '', '', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', '', 'L (H+I+J+K)', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', '(M thru S)', '(L+T)'
        ];
        const headerRow = worksheet.addRow(headers);

        worksheet.mergeCells('N1:O1');
        worksheet.getCell('N1').value = 'K Increment';
        worksheet.getCell('N1').alignment = { horizontal: 'center', vertical: 'middle' };

        headerRow.eachCell((cell) => {
            cell.style.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1F77B4' }
            };
            cell.style.font = {
                bold: true,
                color: { argb: 'FFFFFF' }
            };
        });

        // Updated second header row with DEPT_NO and DIVISION NAME
        const additionalHeaders = [
            'Sr.No', 'DEPT_NO', 'DIVISION NAME', 'Account Name', 'Funding Source', 'Pos No.', 'Position Title', 'Name Of Incumbent', 'Recent Hire Date', 'Grade / Step',
            'Annual Salary', 'O/T', 'Special', 'Date', 'Amt', 'Subtotal',
            'Retire', 'Retire(DDI)', 'Soc.Sec', 'Medicare', 'Life', 'Medical', 'Dental',
            'Total Benefits', 'Total'
        ];
        const additionalHeaderRow = worksheet.addRow(additionalHeaders);

        additionalHeaderRow.eachCell((cell) => {
            if (cell.value) {
                cell.style.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFC000' }
                };
                cell.style.font = {
                    bold: true,
                    color: { argb: '000000' }
                };
            }
        });

        // Add data rows
        let rowCount = 1;
        Object.keys(serverData).forEach((departmentName) => {
            const department = serverData[departmentName];
            Object.keys(department).forEach((divisionName) => {
                department[divisionName].forEach((item) => {
                    const row = [
                        rowCount++,
                        item["DEPT_NO"] || '',
                        item["DIVISION NAME"] || '',
                        item["AccountName"],
                        item["FundingSource"],
                        item["Pos No."],
                        item["Position Title"],
                        item["Name Of Incumbent"],
                        item["Recent Hire Date"] ? new Date(item["Recent Hire Date"]).toLocaleDateString('en-US') : '',
                        item["Grade /Step"],
                        item["Salary"] !== null ? item["Salary"].toLocaleString('en-US') : '',
                        item["O/T"] !== null ? item["O/T"].toLocaleString('en-US') : '',
                        item["Special"] !== null ? item["Special"].toLocaleString('en-US') : '',
                        item["Increment Date"] ? new Date(item["Increment Date"]).toLocaleDateString('en-US') : '',
                        item["Increment Amt"] !== null ? item["Increment Amt"].toLocaleString('en-US') : '',
                        item["Subtotal"] !== null ? item["Subtotal"].toLocaleString('en-US') : '',
                        item["Retire"] !== null ? item["Retire"].toLocaleString('en-US') : '',
                        item["Retire(DDI)"] !== null ? item["Retire(DDI)"].toLocaleString('en-US') : '',
                        item["Soc.Sec"] !== null ? item["Soc.Sec"].toLocaleString('en-US') : '',
                        item["Medicare"] !== null ? item["Medicare"].toLocaleString('en-US') : '',
                        item["Life"] !== null ? item["Life"].toLocaleString('en-US') : '',
                        item["Medical"] !== null ? item["Medical"].toLocaleString('en-US') : '',
                        item["Dental"] !== null ? item["Dental"].toLocaleString('en-US') : '',
                        item["Total Benefits"] !== null ? item["Total Benefits"].toLocaleString('en-US') : '',
                        item["Total"] !== null ? item["Total"].toLocaleString('en-US') : '',
                    ];
                    worksheet.addRow(row);
                });
            });
        });

        // Export the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'All-Staffing-Patterns.xlsx';
        link.click();
    };





    useEffect(() => {
        if (responseData && responseData?.results?.length > 0) {
            const departmentTotals = {};


            var groups = ['DEPARTMENT NAME', 'DIVISION NAME'],
                grouped = {};

            responseData?.results.forEach(function (a) {
                groups.reduce(function (o, g, i) {                            // take existing object,
                    o[a[g]] = o[a[g]] || (i + 1 === groups.length ? [] : {}); // or generate new obj, or
                    return o[a[g]];                                           // at last, then an array
                }, grouped).push(a);
            });
            setFinalData(grouped);
            setServerData(grouped);



        }
    }, [responseData]);

    useEffect(() => {
        if (selectedDepartment != "") {

            setFinalData({ [selectedDepartment]: serverData[selectedDepartment] });
        } else {
            setFinalData(serverData);
        }

    }, [selectedDepartment])

    useEffect(() => {
        console.log("he;;", finalData);
    }, [finalData]);
    if (finalData && Object.keys(finalData)?.length > 0) {
        return (
            <>
                {/* <Navbar /> */}
                <div className="container-fluid page-container mt-4 ">

                    <div className='container print-container' style={{ position: "sticky", left: "167px" }}>
                        {/* <div className="row">
                            <div className="col-12 col-md-6"><h3>Government of Guam - Staffing Pattern</h3></div>
                            <div className="col-md-2 dropdown-deparment">
                                <select value={selectedDepartment} onChange={(e) => setSelectedDepartment(e.target.value)} className="form-select" aria-label="Default select example">
                                    <option value="" selected disabled>Select a Department</option>
                                    {Object.keys(serverData).map((department, index) => (
                                        <option key={index} value={department}>{department}</option>
                                    ))}
                                </select>


                            </div>
                            <div className="col-md-4">
                                <div style={{ display: "flex", gap: "10px"}}>
                                <button onClick={handlePrint} className='btn btn-primary printVisible'>Print</button>
                                <button style={{display:'block'}} onClick={() => downloadExcelByDivision(finalData, selectedDepartment)} disabled={!selectedDepartment} className='btn btn-primary printVisible'>Download Excel</button>
                                <button style={{display:'block'}} className='btn btn-primary printVisible' onClick={downloadAllExcel}>
                                    Download All
                                </button>
                                </div>
                            </div>


                        </div> */}
                        <div className="row align-items-center mb-3 p-2 rounded-lg">
                            <div className="col-12 col-md-5">
                                <h4>Government of Guam - Staffing Pattern</h4>
                            </div>

                            <div className="col-md-2">
                                <select
                                    value={selectedDepartment}
                                    onChange={(e) => setSelectedDepartment(e.target.value)}
                                    className="form-select"
                                    aria-label="Select Department"
                                >
                                    <option value="" disabled>Select a Department</option>
                                    {Object.keys(serverData).map((department, index) => (
                                        <option key={index} value={department}>
                                            {department}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-5">
                                <div className="d-flex gap-2 justify-space-between">
                                    <button onClick={handlePrint} className="btn btn-primary printVisible">
                                        Print
                                    </button>
                                    <button
                                        onClick={() => downloadExcelByDivision(finalData, selectedDepartment)}
                                        disabled={!selectedDepartment}
                                        className="btn btn-primary printVisible"
                                    >
                                        Download Excel
                                    </button>
                                    <button
                                        onClick={downloadAllExcel}
                                        disabled={!userData}
                                        className="btn btn-primary"
                                    >
                                        Download All
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                    {Object.keys(finalData).map((department, index) => {
                        // {Object.keys(finalData[selectedDepartment]).map((division, index) => {

                        return Object.keys(finalData[department]).map((division, index) => {
                            return <>
                                <div style={{ position: "sticky", left: 0, background: "#fff", margin: "12px 0 0 10px", padding: "12px" }}>
                                    <span><b>Department</b>: {department}</span>
                                    <span style={{ width: "100px" }}>&nbsp;</span>
                                    <span><b>Division</b>: {division}</span>
                                    <button
                                        style={{ marginLeft: "20px" }}
                                        disabled={!selectedDepartment}
                                        onClick={() => downloadExcel(finalData, department, division)}
                                        className="btn btn-primary"
                                    >
                                        Download Excel
                                    </button>
                                </div>

                                <div key={index} style={{
                                    maxWidth: "100%",
                                    overflowX: "auto"
                                }}>
                                    <table
                                        style={{
                                            width: "max-content",
                                            borderCollapse: "collapse", whiteSpace: "wrap"
                                        }}
                                        className="table mt-3 table-striped table-bordered ">
                                        <thead >
                                            {/* <tr >
                                                <td colSpan={24} style={{position:"sticky", left: 0}}>
                                                    <span><b>Department</b>: {department}</span>
                                                    <span style={{ width: '100px' }}>&nbsp;</span>
                                                    <span><b>Division</b>: {division}</span>
                                                    <button style={{ marginLeft: "20px" }}
                                                        disabled={!selectedDepartment}
                                                        onClick={() => downloadExcel(finalData, department, division)}
                                                        className="btn btn-primary"
                                                    >
                                                        Download Excel
                                                    </button>
                                                </td>
                                            </tr> */}
                                            {/* Add header columns here as per follows as excel */}
                                            <tr>

                                                <th> </th>
                                                <th style={{ width: "120px" }} className='text-center'>(A)</th>
                                                <th style={{ width: "200px" }} className='text-center'>(B)</th>
                                                <th style={{ width: "200px" }} className='text-center'>(C)</th>
                                                <th style={{ width: "100px" }} className='text-center'>(D)</th>
                                                <th style={{ width: "120px" }} className='text-center'>(E)</th>
                                                <th style={{ width: "80px" }} className='text-center'>(F)</th>
                                                <th style={{ width: "80px" }} className='text-center'>(G)</th>
                                                <th style={{ width: "80px" }} className='text-center'>(H)</th>
                                                <th style={{ width: "80px" }} className='text-center'>(I)</th>
                                                <th style={{ width: "80px" }} className='text-center'>(J)</th>
                                                <th style={{ width: "200px" }} className='text-center' colSpan="2">(K)<br />Increment</th>
                                                <th style={{ width: "150px" }} className='text-center'>(L)<br />(H+I+J+K)  </th>
                                                {/* <th className='text-center'>Subtotal <br />(E+F+G+I)  </th>                                                 */}
                                                {/* <th className='text-center' colSpan='7'>Benefits</th> */}
                                                <th style={{ width: "100px" }} className='text-center'>(M)</th>
                                                <th style={{ width: "100px" }} className='text-center'>(N)</th>
                                                <th style={{ width: "100px" }} className='text-center'>(O)</th>
                                                <th style={{ width: "100px" }} className='text-center'>(P)</th>
                                                <th style={{ width: "100px" }} className='text-center'>(Q)</th>
                                                <th style={{ width: "100px" }} className='text-center'>(R)</th>
                                                <th style={{ width: "80px" }} className='text-center'>(S)</th>
                                                <th style={{ width: "150px" }} className='text-center'>(M thru S)</th>
                                                <th style={{ width: "150px" }} className='text-center'>(L+T)</th>
                                            </tr>
                                            <tr>
                                                <th>No.</th>
                                                <th>Account Name</th>
                                                <th>Funding Source</th>
                                                <th>Pos No.</th>
                                                <th>Position Title</th>
                                                <th>Name of Incumbent</th>
                                                <th className='text-center'>Recent Hire Date <br /> </th>
                                                <th>Grade/Step</th>
                                                <th className='text-center'>Annual Salary</th>
                                                <th>O/T</th>
                                                <th>Special</th>


                                                <th>Date</th>
                                                <th>Amount</th>
                                                <th className='text-center'>Subtotal</th>
                                                <th className='text-center'>(H*30.77% )  <br /> Retire</th>
                                                <th className='text-center'>Retire (DD1)</th>
                                                <th className='text-center'>(6.2% *K)  <br /> Soc.Sec </th>
                                                <th className='text-center'>(1.45% *K) <br />  Medicare</th>
                                                <th className='text-center'>Life (187)</th>
                                                <th className='text-center'>Medical <br /> (Prem)</th>
                                                <th>Dental <br /> (Prem)</th>
                                                <th className='text-center'>Total Benefits</th>
                                                <th className='text-center'>Total <br /> </th>


                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Add rows data or datamap here */}
                                            {/* {finalData[department][division].map((item, index) => ( */}
                                            {finalData[department][division].map((item, index) => (

                                                <tr>

                                                    <td>{index + 1}</td>
                                                    <td>{item["AccountName"]}</td>
                                                    <td>{item["FundingSource"]}</td>
                                                    <td>{item["Pos No."]}</td>
                                                    <td>{item["Position Title"]}</td>
                                                    <td>{item["Name Of Incumbent"]}</td>
                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Total"]} */}
                                                        {item["Recent Hire Date"] ? new Date(item["Recent Hire Date"]).toLocaleDateString('en-US') : ''}

                                                    </span></td>
                                                    <td>{item["Grade /Step"]}</td>
                                                    {/* <td className="d-flex justify-content-between">
                                                        <span>$</span>
                                                        {item["Salary"] !== null ? parseFloat(item["Salary"]).toFixed(2) : 0}
                                                    </td> */}
                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Salary"].toLocaleString('en-US')} */}
                                                        <span>$</span> {item["Salary"] !== null ? item["Salary"].toLocaleString('en-US') : ''}
                                                    </span>
                                                    </td>

                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["O/T"]} */}
                                                        <span>$</span> {item["O/T"] !== null ? item["O/T"].toLocaleString('en-US') : ''}

                                                    </span>

                                                    </td>
                                                    <td  ><span className="d-flex justify-content-between"
                                                    >
                                                        <span>$</span> {item["Special"] !== null ? item["Special"].toLocaleString('en-US') : ''}

                                                        {/* <span>$</span> {item["Special"]} */}
                                                    </span>
                                                    </td>


                                                    <td>{item["Increment Date"] ? new Date(item["Increment Date"]).toLocaleDateString('en-US') : ''}</td>

                                                    <td  ><span className="d-flex justify-content-between">
                                                        <span>$</span> {item["Increment Amt"] !== null ? item["Increment Amt"].toLocaleString('en-US') : ''}

                                                        {/* {item["Increment Amt"]} */}
                                                    </span>
                                                    </td>
                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Subtotal"]} */}
                                                        <span>$</span> {item["Subtotal"] !== null ? item["Subtotal"].toLocaleString('en-US') : ''}

                                                    </span></td>

                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Retire"]} */}
                                                        <span>$</span> {item["Retire"] !== null ? item["Retire"].toLocaleString('en-US') : ''}

                                                    </span></td>

                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Retire(DDI)"]} */}
                                                        <span>$</span> {item["Retire(DDI)"] !== null ? item["Retire(DDI)"].toLocaleString('en-US') : ''}

                                                    </span></td>


                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Soc.Sec"]} */}
                                                        <span>$</span> {item["Soc.Sec"] !== null ? item["Soc.Sec"].toLocaleString('en-US') : ''}

                                                    </span></td>

                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Medicare"]} */}
                                                        <span>$</span> {item["Medicare"] !== null ? item["Medicare"].toLocaleString('en-US') : ''}

                                                    </span></td>


                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Life"]} */}
                                                        <span>$</span> {item["Life"] !== null ? item["Life"].toLocaleString('en-US') : ''}

                                                    </span></td>
                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Medical"]} */}
                                                        <span>$</span> {item["Medical"] !== null ? item["Medical"].toLocaleString('en-US') : ''}

                                                    </span></td>
                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Dental"]} */}
                                                        <span>$</span> {item["Dental"] !== null ? item["Dental"].toLocaleString('en-US') : ''}

                                                    </span></td>


                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Total Benefits"]} */}
                                                        <span>$</span> {item["Total Benefits"] !== null ? item["Total Benefits"].toLocaleString('en-US') : ''}

                                                    </span></td>

                                                    <td  ><span className="d-flex justify-content-between">
                                                        {/* <span>$</span> {item["Total"]} */}
                                                        <span>$</span> {item["Total"] !== null ? item["Total"].toLocaleString('en-US') : ''}

                                                    </span></td>



                                                </tr>

                                            ))}
                                            {/* for all department data map data set also map rows data here */}
                                            <tr>
                                                <td colSpan={5}></td>
                                                <td >
                                                    <span className="d-flex justify-content-between">
                                                        <span>$</span>

                                                        {/* <b>{parseInt(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Salary"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseInt(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Salary"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>
                                                    </span>
                                                </td>


                                                <td  >
                                                    <span className="d-flex justify-content-between">

                                                        <span>$</span>
                                                        {/* <b>{parseInt(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["O/T"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseInt(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["O/T"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>

                                                    </span>

                                                </td>
                                                <td  >
                                                    <span className="d-flex justify-content-between">
                                                        <span>$</span>

                                                        {/* <b>{parseInt(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Special"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseInt(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Special"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>
                                                    </span>


                                                </td>
                                                <td></td>
                                                <td  >
                                                    <span className="d-flex justify-content-between">
                                                        <span>$</span>
                                                        <b>
                                                            {parseInt(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Increment Amt"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>
                                                        {/* <b>{parseInt(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Increment Amt"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                    </span>

                                                </td>
                                                <td   >
                                                    <span className="d-flex justify-content-between">
                                                        <span>$</span>
                                                        <b>
                                                            {parseInt(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Subtotal"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>


                                                    </span>

                                                </td>
                                                <td  >
                                                    <span className="d-flex justify-content-between">

                                                        <span>$</span>
                                                        {/* <b>{parseInt(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Retire"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseInt(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Retire"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>
                                                    </span>

                                                </td>
                                                <td   >
                                                    <span className="d-flex justify-content-between">

                                                        <span>$</span>
                                                        {/* <b>{parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Retire(DDI)"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Retire(DDI)"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>
                                                    </span>

                                                </td>
                                                <td   >
                                                    <span className="d-flex justify-content-between">

                                                        <span>$</span>

                                                        {/* <b>{parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Soc.Sec"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Soc.Sec"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>
                                                    </span>

                                                </td>
                                                <td   >
                                                    <span className="d-flex justify-content-between">

                                                        <span>$</span>
                                                        {/* <b>{parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Medicare"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Medicare"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>
                                                    </span>

                                                </td>
                                                <td  >
                                                    <span className="d-flex justify-content-between">

                                                        <span>$</span>
                                                        {/* <b>{parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Life"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Life"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>
                                                    </span>

                                                </td>
                                                <td   >
                                                    <span className="d-flex justify-content-between">

                                                        <span>$</span>
                                                        {/* <b>{parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Medical"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Medical"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>
                                                    </span>

                                                </td>
                                                <td   >
                                                    <span className="d-flex justify-content-between">

                                                        <span>$</span>
                                                        {/* <b>{parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Dental"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Dental"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>
                                                    </span>

                                                </td>
                                                <td   >
                                                    <span className="d-flex justify-content-between">

                                                        <span>$</span>
                                                        {/* <b>{parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Total Benefits"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Total Benefits"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>
                                                    </span>

                                                </td>
                                                <td   >
                                                    <span className="d-flex justify-content-between">

                                                        <span>$</span>
                                                        {/* <b>{parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                            return acc + obj["Total"]
                                                        }, 0)).toFixed(0)}</b> */}
                                                        <b>
                                                            {parseFloat(finalData[department][division].reduce((acc, obj) => {
                                                                return acc + obj["Total"]
                                                            }, 0)).toLocaleString('en-US')}
                                                        </b>

                                                    </span>

                                                </td>

                                            </tr>


                                        </tbody>
                                    </table>
                                </div>
                            </>
                        })

                    })}


                </div>

            </>
        )
    } else {
        return <div class="text-center">
            <div class="spinner-grow" role="status" style={{ width: '5rem', height: '5rem', marginTop: '200px' }}>
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    }

}

export default IndexNew